package ru.villawonka.app.domain.model

enum class AccommodationTypeDomain {
    ROOM,
    VILLA,
    GUESTHOUSE,
    APARTMENT,
}